import { FilterFormBuilder } from "components/filterForms/FilterFormBuilder/FilterFormBuilder";
import { type FilterFormPropsBase } from "components/filterForms/types/props";
import { type ExternalLinksFiltersEnum } from "features/Library/ExternalLinks/types/models";
import { getLinkFilters } from "./linkFilters";

interface FilterFormProps extends FilterFormPropsBase<ExternalLinksFiltersEnum> {}

const LinkFilterForm = (props: FilterFormProps) => (
  <FilterFormBuilder
    filterOptions={props.filterOptions}
    filter={props.filter}
    updateFilter={props.updateFilter}
    items={getLinkFilters(true)}
    onValidationChange={props.onValidationChange}
  />
);

export default LinkFilterForm;
